import { MixPanelEvent, MixPanelEventTypes, PlatformTypes } from './types';
import Constants from '../../../constants/constants';
const MODULE_NAME = 'Therapist Dashboard';
const buildMessageFromUserRole = (
  userRole: string,
  eventType: MixPanelEventTypes,
  pageName: string,
  extraData?: object,
  category?: string,
  activityType?: string,
  activityName?: string,
  selection?: string
) => {
  return new MixPanelEvent(
    userRole === Constants.USER_ROLES.CARE_PARTNER.name ? PlatformTypes.WELLNESS : PlatformTypes.RESTORE,
    MODULE_NAME,
    eventType,
    pageName,
    extraData,
    category,
    activityType,
    activityName,
    selection
  );
};

export default buildMessageFromUserRole;
